import { Toaster } from "sonner";

/** 앱 루트에 한 번 렌더한다. toastService가 띄운 토스트가 여기에 표시된다 */
export function ToastProvider() {
  return (
    <Toaster
      position="top-center"
      expand={false}
      visibleToasts={3}
      gap={8}
      toastOptions={{
        unstyled: true,
      }}
    />
  );
}
